var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sb-412"},[_c('div',{staticClass:"container-41"},[_c('button',{staticClass:"close-btn",attrs:{"type":"button"},on:{"click":_vm.onClose}},[_vm._v("X")]),_vm._v(" "),_vm._t("default")],2)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f557566","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/ScreenBlocker.vue
// module id = 599
// module chunks = 1